"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildEthereumTx = exports.inferTokenAccount = exports.EIP1559ShouldBeUsed = exports.toTransactionRaw = exports.fromTransactionRaw = exports.getGasLimit = exports.formatTransaction = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var logs_1 = require("@ledgerhq/logs");
var common_1 = __importDefault(require("@ethereumjs/common"));
var tx_1 = require("@ethereumjs/tx");
var common_2 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var env_1 = require("../../env");
var modules_1 = require("./modules");
var range_1 = require("../../range");
var logic_1 = require("./logic");
var formatTransaction = function (t, mainAccount) {
    var gasLimit = (0, exports.getGasLimit)(t);
    var account = (t.subAccountId &&
        (mainAccount.subAccounts || []).find(function (a) { return a.id === t.subAccountId; })) ||
        mainAccount;
    var header = (function () {
        var _a, _b;
        switch (t.mode) {
            case "erc721.transfer":
                return "".concat(t.mode.toUpperCase(), " Collection: ").concat(t.collection, " (").concat(t.collectionName || "", ") TokenId: ").concat((_a = t.tokenIds) === null || _a === void 0 ? void 0 : _a[0]);
            case "erc1155.transfer":
                return ("".concat(t.mode.toUpperCase(), " Collection: ").concat(t.collection, " (").concat(t.collectionName || "", ")") +
                    ((_b = t.tokenIds) === null || _b === void 0 ? void 0 : _b.map(function (tokenId, index) {
                        var _a, _b, _c;
                        return "\n  - TokenId: ".concat(tokenId, " Quantity: ").concat((_c = (_b = (_a = t.quantities) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.toFixed()) !== null && _c !== void 0 ? _c : 0);
                    }).join(",")));
            default:
                return "".concat(t.mode.toUpperCase(), " ").concat(t.useAllAmount
                    ? "MAX"
                    : (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), t.amount, {
                        showCode: true,
                        disableRounding: true
                    }));
        }
    })();
    var feesMessage;
    if (EIP1559ShouldBeUsed(mainAccount.currency)) {
        feesMessage =
            "with maxFeePerGas=".concat((0, currencies_1.formatCurrencyUnit)((0, logic_1.getDefaultFeeUnit)(mainAccount.currency), t.maxFeePerGas || new bignumber_js_1.BigNumber(0)), "\n") +
                "with maxPriorityFeePerGas=".concat((0, currencies_1.formatCurrencyUnit)((0, logic_1.getDefaultFeeUnit)(mainAccount.currency), t.maxPriorityFeePerGas || new bignumber_js_1.BigNumber(0)));
    }
    else {
        feesMessage = "with gasPrice=".concat((0, currencies_1.formatCurrencyUnit)((0, logic_1.getDefaultFeeUnit)(mainAccount.currency), t.gasPrice || new bignumber_js_1.BigNumber(0)));
    }
    return "\n".concat(header, "\nTO ").concat(t.recipient, "\n").concat(feesMessage, "\nwith gasLimit=").concat(gasLimit.toString());
};
exports.formatTransaction = formatTransaction;
var defaultGasLimit = new bignumber_js_1.BigNumber(21000);
var getGasLimit = function (t) {
    return t.userGasLimit || t.estimatedGasLimit || defaultGasLimit;
};
exports.getGasLimit = getGasLimit;
var fromTransactionRaw = function (tr) {
    var _a;
    var common = (0, common_2.fromTransactionCommonRaw)(tr);
    var networkInfo = tr.networkInfo;
    return __assign(__assign({}, common), { mode: tr.mode, nonce: tr.nonce, data: tr.data ? Buffer.from(tr.data, "hex") : undefined, family: tr.family, gasPrice: tr.gasPrice ? new bignumber_js_1.BigNumber(tr.gasPrice) : null, maxFeePerGas: tr.maxFeePerGas ? new bignumber_js_1.BigNumber(tr.maxFeePerGas) : null, maxPriorityFeePerGas: tr.maxPriorityFeePerGas
            ? new bignumber_js_1.BigNumber(tr.maxPriorityFeePerGas)
            : null, userGasLimit: tr.userGasLimit ? new bignumber_js_1.BigNumber(tr.userGasLimit) : null, estimatedGasLimit: tr.estimatedGasLimit
            ? new bignumber_js_1.BigNumber(tr.estimatedGasLimit)
            : null, feeCustomUnit: tr.feeCustomUnit, 
        // FIXME this is not good.. we're dereferencing here. we should instead store an index (to lookup in currency.units on UI)
        networkInfo: networkInfo && {
            family: networkInfo.family,
            gasPrice: networkInfo.gasPrice
                ? (0, range_1.fromRangeRaw)(networkInfo.gasPrice)
                : undefined,
            nextBaseFeePerGas: networkInfo.nextBaseFeePerGas
                ? new bignumber_js_1.BigNumber(networkInfo.nextBaseFeePerGas)
                : undefined,
            maxPriorityFeePerGas: networkInfo.maxPriorityFeePerGas
                ? (0, range_1.fromRangeRaw)(networkInfo.maxPriorityFeePerGas)
                : undefined
        }, allowZeroAmount: tr.allowZeroAmount, feesStrategy: tr.feesStrategy, tokenIds: tr.tokenIds, collection: tr.collection, collectionName: tr.collectionName, quantities: (_a = tr.quantities) === null || _a === void 0 ? void 0 : _a.map(function (q) { return new bignumber_js_1.BigNumber(q); }) });
};
exports.fromTransactionRaw = fromTransactionRaw;
var toTransactionRaw = function (t) {
    var _a;
    var common = (0, common_2.toTransactionCommonRaw)(t);
    var networkInfo = t.networkInfo;
    return __assign(__assign({}, common), { mode: t.mode, nonce: t.nonce, family: t.family, data: t.data ? t.data.toString("hex") : undefined, gasPrice: t.gasPrice ? t.gasPrice.toString() : null, maxFeePerGas: t.maxFeePerGas ? t.maxFeePerGas.toString() : null, maxPriorityFeePerGas: t.maxPriorityFeePerGas
            ? t.maxPriorityFeePerGas.toString()
            : null, userGasLimit: t.userGasLimit ? t.userGasLimit.toString() : null, estimatedGasLimit: t.estimatedGasLimit
            ? t.estimatedGasLimit.toString()
            : null, feeCustomUnit: t.feeCustomUnit, 
        // FIXME drop?
        networkInfo: networkInfo && {
            family: networkInfo.family,
            gasPrice: networkInfo.gasPrice
                ? (0, range_1.toRangeRaw)(networkInfo.gasPrice)
                : undefined,
            nextBaseFeePerGas: networkInfo.nextBaseFeePerGas
                ? networkInfo.nextBaseFeePerGas.toString()
                : undefined,
            maxPriorityFeePerGas: networkInfo.maxPriorityFeePerGas
                ? (0, range_1.toRangeRaw)(networkInfo.maxPriorityFeePerGas)
                : undefined
        }, allowZeroAmount: t.allowZeroAmount, feesStrategy: t.feesStrategy, tokenIds: t.tokenIds, collection: t.collection, collectionName: t.collectionName, quantities: (_a = t.quantities) === null || _a === void 0 ? void 0 : _a.map(function (q) { return (q === null || q === void 0 ? void 0 : q.toFixed()) || "0"; }) });
};
exports.toTransactionRaw = toTransactionRaw;
// see https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md
function getEthereumjsTxCommon(currency) {
    var ethereumLikeInfo = currency.ethereumLikeInfo;
    (0, invariant_1["default"])(ethereumLikeInfo, "currency ".concat(currency.id, " did not set ethereumLikeInfo"));
    if (ethereumLikeInfo.chainId === 1) {
        return new common_1["default"]({
            chain: ethereumLikeInfo.baseChain || "mainnet",
            hardfork: ethereumLikeInfo.hardfork || "london"
        });
    }
    return common_1["default"].custom({
        name: ethereumLikeInfo.baseChain || "mainnet",
        chainId: ethereumLikeInfo.chainId,
        networkId: ethereumLikeInfo.networkId || ethereumLikeInfo.chainId,
        defaultHardfork: ethereumLikeInfo.hardfork || "london"
    });
}
function EIP1559ShouldBeUsed(currency) {
    return (0, env_1.getEnv)("EIP1559_ENABLED_CURRENCIES").includes(currency.id);
}
exports.EIP1559ShouldBeUsed = EIP1559ShouldBeUsed;
function inferTokenAccount(a, t) {
    var tokenAccount = !t.subAccountId
        ? null
        : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
    if (tokenAccount && tokenAccount.type === "TokenAccount") {
        return tokenAccount;
    }
}
exports.inferTokenAccount = inferTokenAccount;
function buildEthereumTx(account, transaction, nonce) {
    var currency = account.currency;
    var gasPrice = transaction.gasPrice, maxFeePerGas = transaction.maxFeePerGas, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas;
    var subAccount = inferTokenAccount(account, transaction);
    (0, invariant_1["default"])(!subAccount || subAccount.type === "TokenAccount", "only token accounts expected");
    var common = getEthereumjsTxCommon(currency);
    if (!common) {
        throw new Error("common not found for currency ".concat(currency.name));
    }
    var gasLimit = (0, exports.getGasLimit)(transaction);
    var ethTxObject = {
        nonce: nonce,
        gasLimit: "0x".concat(new bignumber_js_1.BigNumber(gasLimit).toString(16))
    };
    var mode = modules_1.modes[transaction.mode];
    (0, invariant_1["default"])(mode, "missing module for mode=" + transaction.mode);
    var fillTransactionDataResult = mode.fillTransactionData(account, transaction, ethTxObject);
    var tx;
    if (EIP1559ShouldBeUsed(currency)) {
        ethTxObject.maxFeePerGas = "0x".concat(new bignumber_js_1.BigNumber(maxFeePerGas || 0).toString(16));
        ethTxObject.maxPriorityFeePerGas = "0x".concat(new bignumber_js_1.BigNumber(maxPriorityFeePerGas || 0).toString(16));
        (0, logs_1.log)("ethereum", "buildEIP1559Transaction", ethTxObject);
        tx = new tx_1.FeeMarketEIP1559Transaction(ethTxObject, {
            common: common
        });
    }
    else {
        ethTxObject.gasPrice = "0x".concat(new bignumber_js_1.BigNumber(gasPrice || 0).toString(16));
        (0, logs_1.log)("ethereum", "buildLegacyEthereumTransaction", ethTxObject);
        tx = new tx_1.Transaction(ethTxObject, { common: common });
    }
    return {
        tx: tx,
        common: common,
        ethTxObject: ethTxObject,
        fillTransactionDataResult: fillTransactionDataResult
    };
}
exports.buildEthereumTx = buildEthereumTx;
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: exports.fromTransactionRaw,
    toTransactionRaw: exports.toTransactionRaw,
    fromTransactionStatusRaw: common_2.fromTransactionStatusRawCommon,
    toTransactionStatusRaw: common_2.toTransactionStatusRawCommon,
    formatTransactionStatus: common_2.formatTransactionStatusCommon
};
//# sourceMappingURL=transaction.js.map